import { ClassActivity } from './class-activity';
import { Base } from './base-model';
import { Type } from 'class-transformer';

export class ClassType extends Base {
    name: string
    @Type(() => ClassActivity)
    activities: ClassActivity[]
}
